export const categories = [
  {
    id: "industrial-connectors",
    name: "工业级插接器",
    slug: "industrial-connectors",
    description: "专为严苛工业环境设计的高强度插接器，抗冲击、耐腐蚀、防水防尘，确保生产线持续稳定运行。",
    imageQuery: "Heavy-duty industrial electrical connectors with rugged metal housing, waterproof sealing, professional workshop background with machinery, clean product photography, warm neutral lighting, high detail",
    productCount: 24,
  },
  {
    id: "household-connectors",
    name: "家用插接配件",
    slug: "household-connectors",
    description: "安全可靠的家用插接解决方案，简约设计、易安装，为家居电气连接提供持久保护。",
    imageQuery: "Modern household electrical plug and socket connectors, minimalist white design, clean home interior background, soft natural light, lifestyle product photography, warm tones",
    productCount: 18,
  },
  {
    id: "construction-connectors",
    name: "施工专用插接装置",
    slug: "construction-connectors",
    description: "为专业施工场景打造的插接装置，耐磨损、抗拉扯，适应各种恶劣施工环境。",
    imageQuery: "Professional construction site electrical connectors, durable heavy-duty plugs and sockets, orange and black industrial design, construction background with tools, bright clear lighting, sharp detail",
    productCount: 16,
  },
  {
    id: "precision-connectors",
    name: "精密插接组件",
    slug: "precision-connectors",
    description: "高精度插接组件，适用于精密仪器和高端设备，微米级公差确保信号传输零损耗。",
    imageQuery: "Precision miniature electronic connectors with gold-plated contacts, laboratory clean room background, macro photography style, soft diffused lighting, technical aesthetic, high detail",
    productCount: 12,
  },
  {
    id: "waterproof-series",
    name: "防水插接系列",
    slug: "waterproof-series",
    description: "IP67/IP68 级防水插接器，适用于户外、水下及潮湿环境，全方位防水防尘保护。",
    imageQuery: "IP68 waterproof electrical connectors with blue rubber seals, outdoor rainy environment background, water droplets on connector surface, dramatic lighting, professional product photography, clean composition",
    productCount: 20,
  },
  {
    id: "custom-solutions",
    name: "定制插接方案",
    slug: "custom-solutions",
    description: "根据客户需求定制的插接解决方案，从设计到量产全程服务，满足特殊场景需求。",
    imageQuery: "Custom engineered electrical connector prototypes on technical drawing blueprints, engineering office background, warm desk lamp lighting, professional industrial design photography, detailed macro view",
    productCount: 8,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};